/**
 * JQuery
 */
try {
    window.$ = window.jQuery = require("jquery");
} catch (e) {}

/**
 * Boostrap App
 */
require("bootstrap");
require("./teamplate.js");

/**
 * Vue
 */
import Vue from "vue";
import EstablishmentsMap from "./components/vue/EstablishmentsMap.vue";

new Vue({
    el: "#app",
    components: {
        EstablishmentsMap,
    },
});

/**
 * Custom JS Components
 */
require("./components/cropper.js");
require("./components/datatables.js");
require("./components/maps.js");
require("./components/sweetalert.js");
require("./components/uppy.js");
require("./components/selectable");
require("./components/json");
require("./components/select2");
